var pInfScrLoading = false;
var pInfScrDelay = 250;
function pInfScrExecute() {
	pInfScrNode = $('.more').last();	
	pInfScrURL = $('.more a').last().attr("href");
	if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
		$.ajax({
			type: 'GET',
			url: pInfScrURL,
			beforeSend: function() {
			  pInfScrLoading = true;
			  pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
			  pInfScrNode.hide();
			},
			success: function(data) {
				// remove loading feedback
				pInfScrNode.next().remove();
				pInfScrNode.remove();
				var filteredData = $(data).find(".collection-matrix");
				filteredData.insertBefore( $("#product-list-foot") );					
				pInfScrLoading = false;
				//$('li.singleproduct').setAllToMaxHeight();
				attachClickEvent();
			},
          complete: function(){
            
   		 
            
//         $("a.collectionswatch").on('mouseover',function(){ 
//           var imgid = $(this).attr("data-id");
//           console.log(imgid);
//           $(this).parent().parent().parent().parent().children().children().children().children().children("img.image111").attr("src",$(this).attr("data-src"));
//           $(this).parent().parent().parent().parent().children().children().children().children().children("img.image111").attr("data-src",$(this).attr("data-src"));
//           $("#"+imgid+"-link").attr("href",$(this).attr("data-url"));
//         });
      
//          $(".grid-view-item").on('mouseleave',function(){ 
//     	   var imgid = $(this).attr("data-id");
//            var dataurl = $(this).children("a.producturl").children(".currentproductdata").attr("data-url");
//            var dataimg = $(this).children("a.producturl").children(".currentproductdata").attr("data-img1");
         
//           $(this).children().children().children().children("img.image111").attr("src",dataimg);
//           $(this).children().children().children().children("img.image111").attr("data-src",dataimg);
//           $("#"+imgid+"-link").attr("href",dataurl);
//         });

           
				
			
            
         var w = $( window ).width();
     
   },
			dataType: "html"
		});

	}
}

function attachClickEvent(){
	$('div.more a').click(function(event){
		pInfScrExecute();
		event.stopPropagation();
		return false;
	});
}

$(document).ready(function(){
  $('#shopify-section-collection-template').on('mouseover','.customColor', function(){
    var img= $(this).attr('data-image');
    $(this).closest('.grid-view-item').find('.grid-view-item__image').attr('src',img);
  });
});